/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import axios from 'axios'
import { Link } from 'react-router-dom'

import Dashboard from '../user/Dashboard'
import ViewFeedback from '../reviewing/ViewFeedback'
import ReviewerProfile from '../reviewing/ReviewerProfile'
import RequestFeedback from '../requestFeedback/RequestFeedback'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import { swipelyticsTurquoise, swipelyticsPink, positionChangeWidthSm, navbarHeight, footerHeight, demoUsersArray, testProductImageDimension, aiReviewRate } from '../../helpers/variableDefaults'
import { seoPageTags } from '../../helpers/analytics'
import { standardSpinner } from '../../helpers/spinners'
import { shuffleArray } from '../../helpers/globalHelpers' 
import useWindowDimensions from '../../helpers/windowDimensions'

// Test Dashboard Page
const TestDashboard = (props) => {

  // use Naviage
  const navigate = useNavigate()

  // Window Dimensions
  const { height, width } = useWindowDimensions()

  // URL Path
  const location = useLocation()
  const urlPath = window.location.pathname
  const urlPathEnding = urlPath.split('/').pop()
  // console.log('urlPath ->', urlPath)

  // Params
  const { testUserFirstName, profileType, reviewerFirstName } = useParams()


  // States
  const userToSet = { ...demoUsersArray.filter(demoUser => demoUser.bio.vitalInfo.firstName.toLowerCase() === testUserFirstName.toLowerCase())[0] }
  const [demoUser, setDemoUser] = useState({ ...userToSet })

  // View Indexes ——— 0 = Dashboard; 1 = View Feedback; 2 = ReviewerProfile; 3 = Request Feedback
  const [demoViewIndex, setDemoViewIndex] = useState(urlPathEnding === 'dashboard' ? 0 : urlPathEnding === 'profile-overview' ? 1 : urlPathEnding === 'edit-profile' ? 2 : urlPathEnding === 'view-feedback' ? 3 : urlPathEnding === 'reviewer-profile' ? 4 : urlPathEnding === 'request-feedback' ? 5 : 0)
  // const [demoDashboardViewIndex, setDemoDashboardViewIndex] = useState(0)

  // Stripe Options
  const [stripePaymentForm, setStripePaymentForm] = useState({
    amount: aiReviewRate * 100,
    currency: 'usd',
    mode: 'payment',
  })

  useEffect(() => {
    // console.log('starter useEffect runs')
  }, [])

  // Use Effects
  useEffect(() => {
    // console.log('demoViewIndex useEffect runs')
    // console.log('estatesArray event ->', estatesArray[estateSelectedIndex].event[0])
    
  }, [
    demoUser
    , 
    demoViewIndex
  ])

  useEffect(() => {
    // console.log('location useEffect runs')
    setDemoViewIndex(urlPathEnding === 'dashboard' ? 0 : urlPathEnding === 'view-feedback' ? 1 : urlPathEnding === 'reviewer-profile' ? 2 : urlPathEnding === 'request-feedback' ? 3 : 0)
  }, [location])


  return (
    <>
      {/* Helmet — for analytics, seo, and page title changing */}
      {/* {seoPageTags(
        'Test Dashboard'
      )} */}

      {/* Body */}
      <Box 
        sx={{ 
          minHeight: `calc(100vh - ${navbarHeight} - ${footerHeight})`, 
          width: '100vw', 
          // backgroundColor: 'orange',
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', 
        }}
      >
        {/* 0 — Dashboard */}
        {demoViewIndex === 0 &&
          <Dashboard isDemo={true} demoUser={demoUser} />
        }

        {/* 1 — View Feedback */}
        {demoViewIndex === 1 &&
          <ViewFeedback isDemo={true} demoUser={demoUser} profileType={profileType} reviewerFirstName={reviewerFirstName} />
        }

        {/* 2 — Reviewer Profile */}
        {demoViewIndex === 2 &&
          <ReviewerProfile isDemo={true} demoUser={demoUser} profileType={profileType} reviewerFirstName={reviewerFirstName} />
        }

        {/* 3 — Request Feedback */}
        {demoViewIndex === 3 &&
          <RequestFeedback stripePaymentForm={stripePaymentForm} setStripePaymentForm={setStripePaymentForm} isDemo={true} demoUser={demoUser} profileType={profileType} />
        }

      </Box>
    </>
  )
}

export default TestDashboard